export const fastingOptions = [
  { label: "Fasting 8-10 hrs", value: "8-10 hrs" },
  { label: "Fasting 10-12 hrs", value: "10-12 hrs" },
  { label: "No Fasting Needed", value: "none" },
];
